import { render } from "./QwilrFormPage.vue?vue&type=template&id=e46cd63a&ts=true"
import script from "./QwilrFormPage.vue?vue&type=script&lang=ts"
export * from "./QwilrFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__